import React from 'react';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components/macro';
import {
  Checkbox as _Checkbox,
  ListItemIcon as _ListItemIcon,
  ListItemText as _ListItemText,
  OutlinedInput as _OutlinedInput
} from '@material-ui/core';
import { BASIC_OPTIONS } from '../engine/DueDateFilterEngine';
import { DatePicker as _DatePicker } from '@material-ui/pickers';
import moment from '../../../utils/momentWithLocale';

const DisplayInput = styled(Input)`
  && {
    cursor: pointer;
    padding: 0.1em 0.8em;
    margin: 0.4em 0;
    max-width: 35em;
    background: #fff;
    border: 1px solid #c4c4c4;
    border-radius: 6px;
    &:hover {
      border: 1px solid #000;
    }
    transition: 0.2s;
  }
  input {
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }

  &&:before,
  &&:after {
    border-bottom: 0 none !important;
    content: none;
  }
`;

const DropDownMenu = styled(Menu)`
  [class*='MuiPopover-paper'] {
    ${({ $variant }) => {
      switch ($variant) {
        case 'contained':
          return 'border-radius: 10px;';

        default:
          break;
      }
    }}
  }
`;

const DateRangeSection = styled.div`
  margin: 0 1rem;
`;
const DateRangeLineOne = styled.div`
  display: flex;
`;
const DateRangeLineTwo = styled.div`
  align-items: center;
  display: flex;
`;
const DateRangeChild = styled.div`
  && {
    font-size: 13px;
    width: 90px;
  }
`;

const DateSpacerChild = styled.div`
  && {
    flex: 1;
    margin: 0 0.5rem;
  }
`;

const DatePicker = styled(_DatePicker)`
  && {
    font-size: 13px;
  }
`;

const ListItemIcon = styled(_ListItemIcon)`
  && {
    height: 30px;
    min-width: 30px;
  }
`;

const ListItemText = styled(_ListItemText)`
  && span {
    font-size: 13px;
  }
`;

const Checkbox = styled(_Checkbox)`
  && svg {
    font-size: 18px !important;
  }
`;

const OutlinedInput = styled(_OutlinedInput)`
  && {
    font-size: 13px;
  }
  && input {
    padding: 0.5rem;
  }
`;

const DueDateFilterView = props => {
  return (
    <>
      <DisplayInput
        inputProps={{ readOnly: true }}
        onClick={props.onClicked}
        placeholder="Due date"
        variant="outlined"
        value={props.displayValue}
        endAdornment={
          <InputAdornment position="end">
            <ArrowDropDown />
          </InputAdornment>
        }
      />
      <DropDownMenu
        anchorEl={props.anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        getContentAnchorEl={null}
        PaperProps={{
          style: { minWidth: props.menuWidth, maxHeight: 500 }
        }}
        open={props.open}
        onClose={() => props.setOpen(false)}
      >
        <MenuList>
          {BASIC_OPTIONS.map(one => (
            <MenuItem
              key={one.id}
              dense
              button
              onClick={() => props.toggleOption(one.id)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={props.checkedOptions.includes(one.id)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': one.id }}
                />
              </ListItemIcon>
              <ListItemText
                id={one.id}
                primary={
                  one.text + ' (' + (props?.dateCounts[one.id] || '-') + ')'
                }
              />
            </MenuItem>
          ))}
        </MenuList>
        <DateRangeSection>
          <DateRangeLineOne>
            <DateRangeChild>From</DateRangeChild>
            <DateSpacerChild />
            <DateRangeChild>To</DateRangeChild>
          </DateRangeLineOne>
          <DateRangeLineTwo>
            <DateRangeChild>
              <DatePicker
                autoOk
                clearable
                disabled={!props.areDateRangesEnabled}
                inputVariant="outlined"
                TextFieldComponent={OutlinedInput}
                format={moment.localeData().longDateFormat('L')}
                value={props.fromDate ? props.parseDate(props.fromDate) : null}
                maxDate={props.toDate ? props.toDate : undefined}
                onChange={props.updateFromDate}
              />
            </DateRangeChild>
            <DateSpacerChild>&ndash;</DateSpacerChild>
            <DateRangeChild>
              <DatePicker
                autoOk
                clearable
                disabled={!props.areDateRangesEnabled}
                inputVariant="outlined"
                TextFieldComponent={OutlinedInput}
                format={moment.localeData().longDateFormat('L')}
                value={props.toDate ? props.parseDate(props.toDate) : null}
                minDate={props.fromDate ? props.fromDate : undefined}
                onChange={props.updateToDate}
              />
            </DateRangeChild>
          </DateRangeLineTwo>
        </DateRangeSection>
      </DropDownMenu>
    </>
  );
};

export default DueDateFilterView;
